/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TextParserThenConditionType {
  AddToPhonebook = 0,
  DeleteFromPhonebook = 1,
  TransferToMobile = 2,
  TransferToAddress = 3,
  TransferToEmail = 4,
  SendSmsToSenderAgent = 5,
  SendSmsToPhonebook = 6,
  SendReceivedSmsToPhonebook = 7,
  SendSmsFromTemplate = 8,
  TransferSenderMobileToMobile = 9
}
